import { useCallback, useMemo, useState } from 'react';
import { createUserPreferenceStore } from '../../../../lib/preferences';
import { useCurrentSession } from '../../../../stores/session';

export type ListLayout = 'table' | 'cards';

/** Kept per viewer the way table preferences are (06-qol §3), so it follows them to another device. */
const LAYOUT_KEY = 'table.candidate-browse.layout';

export function useListLayout(): readonly [ListLayout, (layout: ListLayout) => void] {
  const userId = useCurrentSession()?.id ?? 'anonymous';
  const store = useMemo(() => createUserPreferenceStore(userId), [userId]);
  const [layout, setLayoutState] = useState<ListLayout>(() => (store.get<string>(LAYOUT_KEY, 'table') === 'cards' ? 'cards' : 'table'));
  const setLayout = useCallback(
    (next: ListLayout): void => {
      setLayoutState(next);
      store.set(LAYOUT_KEY, next);
    },
    [store],
  );
  return [layout, setLayout];
}
